module.exports = __webpack_public_path__ + "media/images/how_it_works/step-4-b98fdf2d79f8b9db1f147324daede135.svg";